<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

import CryptoJS from 'crypto-js';


export default {
  page: {
    title: 'View Union',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage:'',
      successStatus:true,
      processingData:false,
      dateOptions: { year: 'numeric', month: 'long', day: 'numeric' },

      pvtData: "",
      secret: "123#$%",
      encData: "",

      title: 'View Union Details',
      items: [
        {
          text: 'Hibret',
          href: '/',
        },
        {
          text: 'Union',
          href: '/Union',
        },
        {
          text: 'Union: '+this.$route.params.union.id,
          active: true,
        },
      ],
      sex: [
        'Female',
        'Male',
      ],
      employer: [
      ],
      region: [
        'Addis Ababa',
        'Afar',
        'Amhara',
        'Benishangul-Gumuz',
        'Dire Dawa',
        'Gambela',
        'Harari',
        'Oromia',
        'Sidama',
        'Somali',
        'SNNP',
        'Tigray',
      ],
      industryValue: this.$route.params.union.industry,
      federationValue: this.$route.params.union.federation,
      regionValue: this.$route.params.union.region,
      contactId:this.$route.params.union.contactId,
      name: this.$route.params.union.name,
      description: this.$route.params.union.name,
      zoneSubcity:this.$route.params.union.zoneSubcity,
      woreda:this.$route.params.union.woreda,
      kebele:this.$route.params.union.kebele,
      houseNumber:this.$route.params.union.houseNumber,
      additionalInformation:this.$route.params.union.additionalInformation,
      contactNumber:this.$route.params.union.contactNumber,

      notes:this.$route.params.union.notes,
      noOfMembersBeforeDebo:this.$route.params.union.noOfMembersBeforeDebo,
      cbaDateSignedValue:this.$route.params.union.cbaDateSigned,
      cbaDateUpdatedValue:this.$route.params.union.cbaDateUpdated,
      dateEstablishedValue:this.$route.params.union.dateEstablished,

      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      
      calendarConfig: {
          wrap: true, 
          dateFormat: 'd/m/Y',       
        },
    }
  },
  methods: {
      // encryption related methods
      encryptData(passwordData) {
        return CryptoJS.AES.encrypt(passwordData, this.secret).toString();
      },
      decryptData(encryptedData) {
        return CryptoJS.AES.decrypt(
          encryptedData,
          this.secret
        ).toString(CryptoJS.enc.Utf8);

      },

      gotoUnions()
      {
        this.$router.push({ name: 'Union', params: { userId: '123' } });
      },

      gotoEditUnion()
      {
        this.$router.push({ name: 'Edit Union', params: { union: this.$route.params.union } });
      },

      checkStringLength(message)
      {
        if(message.length > 0)
        return true;
        else
        return false;
      }
      
  },
  mounted()
  {
    
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="$t('page.union.viewUnionTitle')" />
    
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{ $t('page.union.unionInformation') }}</h4>
            <p class="sub-header"
              ></p
            >

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionId') }}</span>
                <h5 class="mt-0 mb-1" >{{ this.$route.params.union.id }}</h5>
              </div>
            
              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionName') }}</span>
                <h5 class="mt-0 mb-1" >{{ name }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionDescription') }}</span>
                <h5 class="mt-0 mb-1" >{{ description }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionIndustry') }}</span>
                <h5 class="mt-0 mb-1" >{{ industryValue }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionFederation') }}</span>
                <h5 class="mt-0 mb-1" >{{ federationValue }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionContactId') }}</span>
                <h5 class="mt-0 mb-1" >{{ contactId }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionPhoneNumber') }}</span>
                <h5 class="mt-0 mb-1" >{{ contactNumber }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionDateEstablished') }}</span>
                <h5 class="mt-0 mb-1" >{{ dateEstablishedValue }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionNumberOfMembers') }}</span>
                <h5 class="mt-0 mb-1" >{{ noOfMembersBeforeDebo }}</h5>
              </div>
              
              
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->

      
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{ $t('page.union.unionAddressTitle') }}</h4>
            <p class="sub-header"
              ></p
            >
            
              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionRegion') }}</span>
                <h5 class="mt-0 mb-1" >{{ regionValue }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionZone') }}</span>
                <h5 class="mt-0 mb-1" >{{ zoneSubcity }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionWoreda') }}</span>
                <h5 class="mt-0 mb-1" >{{woreda}}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionKebele') }}</span>
                <h5 class="mt-0 mb-1" >{{ kebele }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionHouseNumber') }}</span>
                <h5 class="mt-0 mb-1" >{{ houseNumber }}</h5>
              </div>

              <div v-if="additionalInformation.length" class="form-group">
                <span class="sub-header">{{ $t('page.union.additionalInfo') }}</span>
                <h5 class="mt-0 mb-1" >{{ additionalInformation }}</h5>
              </div>
              
              
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{ $t('page.union.unionCBATitle') }}</h4>
            <p class="sub-header"
              ></p
            >
            
              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionCBADateSigned') }}</span>
                <h5 class="mt-0 mb-1" >{{ cbaDateSignedValue }}</h5>
              </div>

              <div class="form-group">
                <span class="sub-header">{{ $t('page.union.unionCBADateUpdated') }}</span>
                <h5 class="mt-0 mb-1" >{{ cbaDateUpdatedValue }}</h5>
              </div>

              <div v-if="notes.length" class="form-group">
                <span class="sub-header">{{ $t('page.union.notes') }}</span>
                <h5 class="mt-0 mb-1" >{{notes}}</h5>
              </div>

              
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
                  
            <!--form @submit.prevent="handleSubmit">
                  <button v-if='!processingData' type="submit" class="btn btn-primary"
                    >Save</button>
                  <button v-else disabled  class="btn btn-primary"
                  >Save</button>
                  <a href="/member">
                  <button class="btn btn-secondary m-l-5 ml-1"
                    >Cancel</button></a>
            </form-->
            <form @submit.prevent="handleSubmit">
            <template>
              <b-button variant="primary" @click="gotoEditUnion"><i class="uil uil-pen mr-1"></i>{{ $t('page.union.editUnionDetails') }}</b-button>
              <b-button variant="success" style="margin-left:10px;"><i class="uil uil-user mr-1"></i>{{ $t('page.union.unionContactDetails') }}</b-button>
							<b-button variant="light" @click="gotoUnions" style="margin-left:10px;">{{ $t('page.union.close') }}</b-button>	
						</template>
            </form>
                  
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    
  </Layout>
</template>
<style scoped>
.btn {
  font-size: 1rem;
}
.btnSmallAm {
  font-size: 0.875rem;
}
.btnSmallEn {
  font-size: 0.675rem;
}
.lighterTextAm {
  font-weight: 500 !important;
  font-size: 1rem !important;
}
.lighterTextEn {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallAm {
  font-weight: 500 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallEn {
  font-weight: 600 !important;
  font-size: 0.675rem !important;
}
</style>
